




















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import usuarioModule from "@/store/usuario/UsuarioModule";
import PromoCard from "@/components/private/home-page/PromoCard.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";
import { servicoService } from "@/service/ServicoService";
// @ts-ignore
import _ from 'lodash';
@Component({
  components: {
    PromoCard
  }
})
export default class HomePage extends Vue {

  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  filtro: any = {
    inicio: undefined,
    fim: undefined,
    periodo: undefined
  };

  tempoAtualizacaoPagina: number = 10000;
  _timerId: any = null;
  classeAtiva = 'HOJE';
  
  servicosGente = [{
            id: 1,
            tipo: 'REPAROVEICULAR',
            nome: 'Reparo Veicular',
            icone: 'reparo.svg',
            rota: 'QuestionarioGuincho',
            status: []
        },
        {
            id: 2, 
            tipo: 'GUINCHO', 
            nome: 'Guincho', 
            icone: 'guincho-24h.svg', 
            rota: 'QuestionarioCargaBateria',
            status: []
        },{
            id: 3,
            tipo: 'BATERIA',
            nome: 'Carga de Bateria',
            icone: 'bateria.svg',
            rota: 'QuestionarioGuincho',
            status: []
        },
        {
            id: 4, tipo: 'CHAVEIRO', 
            nome: 'Chaveiro',
            icone: 'chaveiro.svg', 
            rota: 'QuestionarioCargaBateria',
            status: []
        },{
            id: 5,
            tipo: 'TRANSPORTE',
            nome: 'Transporte',
            icone: 'transporte.svg',
            rota: 'QuestionarioGuincho',
            status: []
        },
        {
            id: 6, 
            tipo: 'PNEUS', 
            nome: 'Troca de Pneus', 
            icone: 'pneu.png', 
            rota: 'QuestionarioCargaBateria',
            status: []
        }];


  mounted() {
    this.filtrar('HOJE');
    this._timerId = setInterval(this.filtrarAutomatico, this.tempoAtualizacaoPagina); 
  }

  filtrarAutomatico() {
    servicoService.obterQuantidadeServicos(this.filtro).then( 
          (resposta: any) => {
            this.popularListaMonitorameto(resposta);
        });
  }

  destroyed() {
    clearInterval(this._timerId);
  }

  filtrar(tipo: any) {
    this.classeAtiva = tipo;
    this.$refs.filtroObserver.validate().then((valid: boolean) => {
      if (valid) {

        if (tipo !== 'DIAS') {
          this.filtro.periodo = tipo;
          this.filtro.inicio = '';
          this.filtro.fim = '';
        } else {
          this.filtro.periodo = null;
        }

        servicoService.obterQuantidadeServicos(this.filtro).then( 
          (resposta: any) => {
            this.popularListaMonitorameto(resposta);
        });
      }
    });
    return;
  }

  descobrirStatus(lista: any, tipo: any) : any {
    const result = _.filter(lista, function(o: any) { return o.tipo == tipo; });
    if (result.length > 0) {
      return result[0].status;
    }
    return [];
  }

  popularListaMonitorameto(listaStatus: any) {

    this.servicosGente = [{
            id: 1,
            tipo: 'REPAROVEICULAR',
            nome: 'Reparo Veicular',
            icone: 'reparo.svg',
            rota: 'QuestionarioGuincho',
            status: this.descobrirStatus(listaStatus, 'REPAROVEICULAR')
        },
        {
            id: 2, 
            tipo: 'GUINCHO', 
            nome: 'Guincho', 
            icone: 'guincho-24h.svg', 
            rota: 'QuestionarioCargaBateria',
            status: this.descobrirStatus(listaStatus, 'GUINCHO')
        },{
            id: 3,
            tipo: 'BATERIA',
            nome: 'Carga de Bateria',
            icone: 'bateria.svg',
            rota: 'QuestionarioGuincho',
            status: this.descobrirStatus(listaStatus, 'BATERIA')
        },
        {
            id: 4, tipo: 'CHAVEIRO', 
            nome: 'Chaveiro',
            icone: 'chaveiro.svg', 
            rota: 'QuestionarioCargaBateria',
            status: this.descobrirStatus(listaStatus, 'CHAVEIRO')
        },{
            id: 5,
            tipo: 'TRANSPORTE_ASSOCIADO',
            nome: 'Transporte',
            icone: 'transporte.svg',
            rota: 'QuestionarioGuincho',
            status: this.descobrirStatus(listaStatus, 'TRANSPORTE_ASSOCIADO')
        },
        {
            id: 6, 
            tipo: 'TROCA_PNEU', 
            nome: 'Troca de Pneus', 
            icone: 'pneu.png', 
            rota: 'QuestionarioCargaBateria',
            status: this.descobrirStatus(listaStatus, 'TROCA_PNEU')
        }];
  }

  get nome() {
    const nome = usuarioModule.token?.name.split(' ');
    if (nome) {
      return nome.length > 1 ? `${nome[0]} ${nome[1]}${nome[1].length < 3 && nome[2] ? ` ${nome[2]}` : ''}` : nome[0];
    } else {
      return '';
    }
  }
}
